<div class="toaster">
  @for (toast of toasts(); track toast.id) {
    <toast
      class="shadow-lg"
      [ngClass]="
        toast?.closed
          ? 'animation-fade-to-bottom'
          : 'animation-fade-from-bottom'
      "
      [settings]="toast.settings"
    ></toast>
  }
</div>
